import React from 'react';
import common from '../../../common/common';
import translateService from '../../../common/translateService';
import marketingAndAnalyticsService from '../../../services/marketingAndAnalytics/marketingAndAnalyticsService';
import { isNil, map } from 'lodash';

import './PromoImages.scss';

function PromoImages({ promoImages }) {
    const setMessage = (promoMessage) =>
        !isNil(promoMessage.message) && promoMessage.message !== ''
            ? promoMessage.message
            : '';

    const setMessageSecondary = (promoMessage) =>
        !isNil(promoMessage.messageSecondary) &&
        promoMessage.messageSecondary !== ''
            ? promoMessage.messageSecondary
            : translateService.get(`common.discoverNow`);

    const clickPromoImages = async ({
        linkUrl,
        promoMessage,
        index,
        imageSrc,
    }) => {
        await marketingAndAnalyticsService.recordPromoImagesClick({
            linkUrl,
            promoMessage,
            index,
            imageSrc,
        });
        window.location.href = linkUrl;
    };

    const renderedItems = map(promoImages, (currentItem, idx) => {
        const imageIndex = idx + 1;
        return (
            <div
                key={idx}
                className={`promo-image-${imageIndex}-container image-container`}>
                <div className='image-wrapper'>
                    <a href={currentItem.url}>
                        <figure
                            className={`promo-image promo-image-${imageIndex}`}>
                            <img
                                itemProp='image'
                                src={currentItem.image}
                                alt={currentItem.url}
                                className={`animated-image promo-image promo-image-${imageIndex}`}
                            />
                        </figure>
                    </a>
                    <div className='promo-button-container'>
                        <div
                            className={`promo-message promo-message-${imageIndex}`}>
                            <div className='text-asalink-container'>
                                <span
                                    className={`text-asalink text-asalink-increase promo-images-message  ${common.getSite()}`}
                                    onClick={async () =>
                                        await clickPromoImages({
                                            linkUrl: currentItem.url,
                                            promoMessage:
                                                currentItem.promoMessage,
                                            index: imageIndex,
                                            imageSrc: currentItem.image,
                                        })
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: setMessage(
                                            currentItem.promoMessage
                                        ),
                                    }}></span>
                            </div>
                        </div>
                        <div className='text-asalink-container'>
                            <span
                                className={`text-asalink text-asalink-increase promo-images-message-secondary ${common.getSite()}`}
                                onClick={async () =>
                                    await clickPromoImages({
                                        linkUrl: currentItem.url,
                                        promoMessage: currentItem.promoMessage,
                                        index: imageIndex,
                                        imageSrc: currentItem.image,
                                    })
                                }
                                dangerouslySetInnerHTML={{
                                    __html: setMessageSecondary(
                                        currentItem.promoMessage
                                    ),
                                }}></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    if (promoImages && promoImages.length > 0)
        return (
            <div className={`promo-images`}>
                <div className={`promo-images-${promoImages.length}`}>
                    {renderedItems}
                </div>
            </div>
        );
    return <></>;
}
export default PromoImages;
